import React from 'react';

import { Spin } from 'components';

import './ScrollLoader.styles.scss';

const ScrollLoader = () => {
  return (
    <div className="np-scroll-loader">
      <Spin size="default" />
    </div>
  );
};

export default ScrollLoader;
